export default __webpack_public_path__ + "static/media/restoreIcon.a6e9cb66.svg";